import React from 'react';
import { createRoot } from 'react-dom/client';

import { ColorModeScript } from '@chakra-ui/react';

import AppErrorFallback from 'components/GlobalErrorBoundary/AppErrorFallback';
import GlobalErrorBoundary from 'components/GlobalErrorBoundary';

import App from './App';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found.');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <GlobalErrorBoundary fallback={AppErrorFallback}>
      <ColorModeScript />
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>,
);
